import { Box, Grid, Typography, makeStyles, } from '@material-ui/core';
import React, { useContext, useEffect } from 'react';
import StoryContext from '../../contexts/StoryContext';
import MessageBox from '../MessageBox';
import SubquestionBox from '../SubquestionBox';

function CallToAction() {
  const { lightColor, darkColor } = useContext(StoryContext);

  const classes = makeStyles((theme) => ({
    title: {
      color: `${darkColor} !important`,
      textTransform: 'capitalize',
    }
  }))();

  useEffect(() => {
    // we need to remove and reload the script to force Salsa to update the div.
    const existingScript = document.getElementById('leadSalsa');
    if (existingScript) {
      document.body.removeChild(existingScript);
    }
    const script = document.createElement('script');
    script.src = 'https://default.salsalabs.org/api/widget/template/fbea1f9f-0784-431d-bf39-138dc261d5c3/?tId=059df12e-b664-491e-8d6a-095e1a10b9a2';
    script.id = 'leadSalsa';
    document.body.appendChild(script);
  });

  return (
    <Box displayPrint="none">
      <SubquestionBox color={lightColor}>
        <Grid
          spacing={2}
          container
          direction="row"
          justify="center"
          alignItems="center"
        >
          <Grid item xs={12}>
            <Typography variant="h4" component="h3" align="center" className={classes.title} gutterBottom>
              Call to action
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
            >
              <Grid item xs={10} sm={6}>
                <MessageBox>
                  <Box className="ccdc-salsa">
                    <Box id="059df12e-b664-491e-8d6a-095e1a10b9a2" className="ccdc-salsa" />
                  </Box>
                </MessageBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </SubquestionBox>
    </Box>
  );
}

export default CallToAction;
